<template>
  <v-card class="white--text">
    <v-card-title class="title blue lighten-2">
      คำร้องนักศึกษา
    </v-card-title>
    <v-card-text class="pa-1 blue lighten-1">
      <v-autocomplete
        :items="academicYearItems"
        v-model="academicYear"
        item-value="id"
        item-text="yearSemester"
        label="ปี/ภาคการศึกษา"
        return-object
        hide-details
        outline
        dark
        @change="active = false"
      ></v-autocomplete>
      <v-progress-linear :indeterminate="true" background-color="blue lighten-1"
      color="blue lighten-3" v-if="academicYear && !active"></v-progress-linear>
    </v-card-text>

    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-expand-transition>
    <div v-show="academicYear && active" align="center">
      <v-card-text>
        <data-table :academicYear="academicYear" :personItems="personItems" @active="active = $event"></data-table>
      </v-card-text>
    </div> 
    </v-expand-transition>
    
  </v-card>
</template>

<script>
import DataTable from './dataTable.vue'

export default {
  components: {
    DataTable
  },
  data () {
    return {
      active: false,
      loading: false,
      academicYearItems: [],
      academicYear: null,
      personItems: []
    }
  },
  computed: {

  },
  mounted () {
    this.fetchAcademicYears ()
    this.loadPersons ()
    this.$store.dispatch('requestType/fetchRequestTypes')
    this.$store.dispatch('subject/fetchSubjects')
    this.$store.dispatch('university/fetchFaculties')
  },
  methods: {
    fetchAcademicYears () {
      this.loading = true
      this.$store.dispatch("academicYear/loadItems")
        .then((response) => {
          this.academicYearItems = response.data
          this.loading = false
        }).catch((error)=>{
          console.log('fetchAcademicYears', error)
          this.loading = false
        })
    },
    loadPersons () {
      this.$store.dispatch('person/loadItems')
        .then((response) => {
          // console.log('reload:', response.data )
          this.personItems = response.data
        }).catch((error) => {
          swal('Error!', error.message, 'error')
        })
    }
  },
  watch: {
    academicYear (val) {
      if(val) {
        // setTimeout( ()=> this.active = true, 400)
      }
    },
    active (val) {
      // console.log('watching active...', val)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/index.vue